import { bytesToSize, convertDMSToDD } from './CONSTANT';

// Function to extract EXIF data from an image's EXIF metadata
export function getExifData(exifData) {

    // Helper function to extract latitude and longitude from EXIF GPS data
    const getLatLng = () => {
      console.log("consoling exif data", exifData);  // Log the EXIF data for debugging
      const gps = exifData.exif?.GPS || exifData.exif || {}; // Access GPS data in EXIF
      const latitude = gps.GPSLatitude;  // Latitude from EXIF GPS data
      const longitude = gps.GPSLongitude;  // Longitude from EXIF GPS data
      console.log("consoling lat and long", latitude, longitude);  // Log latitude and longitude

      // If both latitude and longitude exist, convert them from DMS (Degrees, Minutes, Seconds) to DD (Decimal Degrees)
      if (latitude && longitude) {
        const { latitude: lat, longitude: lng } = convertDMSToDD(latitude, gps.GPSLatitudeRef, longitude, gps.GPSLongitudeRef);
        return { latitude: lat, longitude: lng };  // Return the converted coordinates
        console.log("consoling lat and long", lat, lng);  // This line won't be reached because the return statement above ends the function
      }
      return null;  // If latitude or longitude is missing, return null
    };

    // Helper function to get the DateTimeOriginal (timestamp) from the EXIF data
    const getDateTimeOriginal = () => {
      if (exifData.exif && exifData.exif.DateTimeOriginal) {
        return exifData.exif.DateTimeOriginal;  // Return the DateTimeOriginal if present
      } else if (exifData.exif.EXIF && exifData.exif.EXIF.DateTimeOriginal) {
        return exifData.exif.EXIF.DateTimeOriginal;  // Otherwise, check under EXIF
      }
      return null;  // Return null if not found
    };

    // Helper function to get the camera make (brand) from EXIF data
    const getCameraMake = () => {
      if (exifData.exif && exifData.exif.Make) {
        return exifData.exif.Make;  // Return the Make if available
      } else if (exifData.exif.IFD0 && exifData.exif.IFD0.Make) {
        return exifData.exif.IFD0.Make;  // Otherwise, check in the IFD0 section
      }
      return null;  // Return null if not found
    };

    // Helper function to get the camera model from EXIF data
    const getCameraModel = () => {
      if (exifData.exif && exifData.exif.Model) {
        return exifData.exif.Model;  // Return the Model if available
      } else if (exifData.exif.IFD0 && exifData.exif.IFD0.Model) {
        return exifData.exif.IFD0.Model;  // Otherwise, check in the IFD0 section
      }
      return null;  // Return null if not found
    };

    // Helper function to get the MIME type of the image from EXIF data
    const getMimeType = () => {
      if (exifData.exif && exifData.exif.MIMEType) {
        return exifData.exif.MIMEType;  // Return MIME type if available
      } else if (exifData.exif.FILE.MimeType && exifData.exif.FILE.MimeType) {
        return exifData.exif.FILE.MimeType;  // Otherwise, check the FILE section for MimeType
      }
      return null;  // Return null if not found
    };

    // Helper function to get the image width from EXIF data
    const getImageWidth = () => {
      if (exifData.exif && exifData.exif.ImageWidth) {
        return exifData.exif.ImageWidth;  // Return image width if available
      } else if (exifData.exif.COMPUTED && exifData.exif.COMPUTED.Width) {
        return exifData.exif.COMPUTED.Width;  // Otherwise, check the COMPUTED section for width
      }
      return null;  // Return null if not found
    };

    // Helper function to get the image height from EXIF data
    const getHeight = () => {
      if (exifData.exif && exifData.exif.ImageHeight) {
        return exifData.exif.ImageHeight;  // Return image height if available
      } else if (exifData.exif.COMPUTED && exifData.exif.COMPUTED.Height) {
        return exifData.exif.COMPUTED.Height;  // Otherwise, check the COMPUTED section for height
      }
      return null;  // Return null if not found
    };
    
    // Helper function to get the file size and convert it to a readable format
    const getFileSize = () => {
      if (exifData.exif && exifData.exif.FileSize) {
        return bytesToSize(exifData.exif.FileSize);  // Convert file size if available
      } else if (exifData.exif.FILE && exifData.exif.FILE.FileSize) {
        return bytesToSize(exifData.exif.FILE.FileSize);  // Otherwise, check the FILE section for file size
      }
      return null;  // Return null if not found
    };

    // Call getLatLng to extract coordinates
    const latLng = getLatLng();

    // Return an object containing all the extracted EXIF data
    return {
      latitude: latLng?.latitude,  // Latitude from EXIF GPS data
      longitude: latLng?.longitude,  // Longitude from EXIF GPS data
      dateTimeOriginal: getDateTimeOriginal(),  // Original datetime of the image
      cameraMake: getCameraMake(),  // Camera make (brand)
      cameraModel: getCameraModel(),  // Camera model
      mimeType: getMimeType(),  // MIME type of the image
      imageWidth: getImageWidth(),  // Width of the image
      height: getHeight(),  // Height of the image
      fileSize: getFileSize(),  // File size of the image
    };
}
